import * as React from 'react';

import './Spinner.css';

const Spinner: React.FC = () => <div className="Spinner" />;

export default Spinner;
